/**
 * @generated SignedSource<<03d434d875e8b83db6c2754821d3dc24>>
 * @relayHash 8348685eded9b83d5c6e42c6adb74f29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 88b3377d69fb1d9fc69595a100010c6cd4fbcf3d56756b32a7f7174a296a99ff

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useSpaceInviteInputQuery$variables = {
  cloudId: string;
  tenantId: string;
  userId: string;
};
export type useSpaceInviteInputQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly offering: {
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceInviteInput_data">;
};
export type useSpaceInviteInputQuery = {
  response: useSpaceInviteInputQuery$data;
  variables: useSpaceInviteInputQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "jira-software"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "Variable",
  "name": "tenantId",
  "variableName": "tenantId"
},
v8 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v12 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v13 = {
  "kind": "ScalarField",
  "name": "key"
},
v14 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "medium"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v16 = {
  "kind": "ScalarField",
  "name": "projectStyle"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSpaceInviteInputQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "offering",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software\")"
          }
        ]
      },
      {
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SpaceInviteInput_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSpaceInviteInputQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "offering",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v5/*: any*/),
                      (v11/*: any*/)
                    ]
                  },
                  (v10/*: any*/)
                ]
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software\")"
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v6/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "keyword": "",
                  "sortBy": {
                    "order": "DESC",
                    "sortBy": "LAST_ISSUE_UPDATED_TIME"
                  },
                  "types": [
                    "BUSINESS",
                    "SOFTWARE"
                  ]
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              }
            ],
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "allJiraProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v5/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "isGlobalAdmin",
            "args": [
              (v6/*: any*/),
              {
                "kind": "Literal",
                "name": "key",
                "value": "ADMINISTER"
              }
            ],
            "kind": "ScalarField",
            "name": "hasGlobalPermission"
          }
        ]
      },
      {
        "concreteType": "SmartsQueryApi",
        "kind": "LinkedField",
        "name": "smarts",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "kind": "Literal",
                        "name": "product",
                        "value": "jira"
                      },
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "context"
                  },
                  {
                    "kind": "Literal",
                    "name": "maxNumberOfResults",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "modelRequestParams",
                    "value": {
                      "caller": "team-invite-people",
                      "experience": "CgContainerNearbyUser"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "requestingUserId",
                    "value": "context"
                  }
                ],
                "kind": "ObjectValue",
                "name": "recommendationsQuery"
              }
            ],
            "concreteType": "SmartsRecommendedContainerV2",
            "kind": "LinkedField",
            "name": "recommendedContainerV2",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v5/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "type": "JiraProject"
                  },
                  (v11/*: any*/)
                ]
              },
              (v10/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "88b3377d69fb1d9fc69595a100010c6cd4fbcf3d56756b32a7f7174a296a99ff",
    "metadata": {},
    "name": "useSpaceInviteInputQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7ba98f5e9ffc70bfb872747e80073a42";

export default node;
